document.addEventListener('DOMContentLoaded', function() {
  // Find all buttons that are meant to trigger the popup
  const popupTriggerButtons = document.querySelectorAll('a[href="#open-newsletter-popup"]');

  // Find the newsletter popup element itself
  const newsletterPopup = document.querySelector('popup-modal');

  // If we can't find the popup on the page, do nothing.
  if (!newsletterPopup) {
    return;
  }

  // Add a click listener to each trigger button
  popupTriggerButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Stop the link from trying to navigate
      event.preventDefault();

      // Use the theme's built-in function to show the popup
      newsletterPopup.show(button);
    });
  });
});